import React from 'react';
import { createPortal } from 'react-dom';
import { addDaysStr, diffDaysStr } from './agendaUtils';

export default function AgendaMoveDateModal({ event, targetDate, relatedArmados, relatedOperations, onTargetDate, onCancel, onConfirm, saving }) {
  if (!event) return null;
  const currentDate = event.event_date?.slice(0, 10);
  const delta = diffDaysStr(currentDate, targetDate || currentDate);
  const shiftDate = date => date ? addDaysStr(date.slice(0, 10), delta) : null;
  const rows = [
    ...relatedArmados.map(armado => ({
      id: `armado-${armado.id}`,
      label: armado.type === 'desarmado' ? 'Desarmado' : 'Armado',
      title: armado.notes || armado.event_name || event.name,
      from: armado.armado_date?.slice(0, 10),
    })),
    ...relatedOperations.map(operation => ({
      id: `operation-${operation.id}`,
      label: operation.type === 'desarmado' ? 'Desarmado' : 'Armado',
      title: operation.title || operation.note || event.name,
      from: operation.operation_date?.slice(0, 10),
    })),
  ].filter(row => row.from);

  return createPortal(
    <div className="agenda-modal-backdrop" onMouseDown={onCancel}>
      <div className="agenda-modal move-date-modal" onMouseDown={eventClick => eventClick.stopPropagation()}>
        <div className="move-date-main">
          <div className="move-date-head">
            <div><span>Cambiar fecha</span><strong>{event.name}</strong></div>
            <button type="button" onClick={onCancel} aria-label="Cerrar">×</button>
          </div>
          <label className="move-date-field">
            <span>Fecha principal</span>
            <input type="date" value={targetDate || currentDate || ''} onChange={change => onTargetDate(change.target.value)} />
          </label>
          <p className="move-date-summary">
            {delta === 0
              ? 'Seleccioná una nueva fecha para ver el corrimiento.'
              : `El evento se mueve ${Math.abs(delta)} dia${Math.abs(delta) === 1 ? '' : 's'} ${delta > 0 ? 'hacia adelante' : 'hacia atras'}.`}
          </p>
          <div className="move-date-actions">
            <button type="button" className="ag-btn" onClick={onCancel}>Cancelar</button>
            <button type="button" className="ag-btn ag-btn-primary" disabled={saving || !targetDate || targetDate === currentDate} onClick={onConfirm}>
              {saving ? 'Moviendo...' : 'Mover evento'}
            </button>
          </div>
        </div>
        <div className="move-date-preview">
          <span>Nuevas fechas</span>
          {rows.length === 0 ? <p>No hay armados o desarmados asociados para correr.</p> : rows.map(row => (
            <div className="move-date-preview-row" key={row.id}>
              <strong>{row.label}</strong><span>{row.from} → {shiftDate(row.from)}</span><small>{row.title}</small>
            </div>
          ))}
        </div>
      </div>
    </div>,
    document.body,
  );
}
